import { useLocation, useNavigate } from 'react-router-dom';

// Custom hook to get and set query parameters
export const useQueryParams = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const getQueryParams = () => {
    return new URLSearchParams(location.search);
  };

  const setQueryParams = (params) => {
    const query = new URLSearchParams(params).toString();
    navigate(`${location.pathname}?${query}`, { replace: true });
  };

  return { getQueryParams, setQueryParams };
};
